import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BodyText, theme, useResponsive } from '@sg/garnish';

import {
  SupportedOrganizationLinkFooterActions,
  type useOrganizationLinksFooterContentfulData,
} from '@order/hooks';

import { OrganizationLink } from '../../OrganizationLink';

export const OrganizationLinksFooterSection = (props: SectionProps) => {
  const { section, conditionalLinksRules } = props;

  const { match } = useResponsive();

  return (
    <View style={match([styles.xsMargin, undefined])}>
      <BodyText style={styles.title}>{section.name}</BodyText>

      {section.links.map((link) => {
        const Link = getOrganizationLink(link);

        return <Link key={link.label} link={link} />;
      })}

      {/* Links that will be displayed only if the specified conditions are met. */}
      {section.conditionalLinks?.map((link) => {
        const Link = getOrganizationLink(link);
        const canBeRendered = link.id ? conditionalLinksRules?.[link.id] === true : false; // prettier-ignore

        return canBeRendered ? <Link key={link.label} link={link} /> : null;
      })}
    </View>
  );
};

// ─── Utils ───────────────────────────────────────────────────────────────

function getOrganizationLink(link: SectionProps['section']['links'][0]) {
  switch (link.specialHandler) {
    case SupportedOrganizationLinkFooterActions.ContactUs: {
      return OrganizationLink.ContactUs;
    }

    default: {
      return OrganizationLink;
    }
  }
}

// ─── Types ───────────────────────────────────────────────────────────────

type SectionProps = Readonly<{
  section: ReturnType<
    typeof useOrganizationLinksFooterContentfulData
  >['sections'][0];
  conditionalLinksRules?: Record<string, boolean>;
}>;

// ─── Styles ──────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    marginBottom: theme.spacing['4'],
    textTransform: 'uppercase',
  },
  xsMargin: {
    marginBottom: theme.spacing['4'],
  },
});
